import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import SectionTitle from './SectionTitle';

const {FiExternalLink, FiDownload, FiFileText} = FiIcons;

export default function PdfViewer({eyebrow, title, intro, url, frameTitle}) {
  return (
    <div>
      <SectionTitle eyebrow={eyebrow} title={title}>{intro}</SectionTitle>

      {/* Mobile: file card with large buttons */}
      <div className="mt-8 rounded-3xl border border-slate-200 bg-slate-50 p-6 text-center sm:hidden">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#3fc0fa]/20">
          <SafeIcon icon={FiFileText} className="h-8 w-8 text-[#0b1423]" />
        </span>
        <p className="mt-4 text-lg font-bold">{frameTitle}</p>
        <p className="mt-1 text-sm text-slate-500">PDF document</p>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="site-button mt-6 flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 text-base font-bold"
        >
          <SafeIcon icon={FiExternalLink} /> Open PDF
        </a>
        <a
          href={url}
          download
          className="mt-3 flex w-full items-center justify-center gap-2 rounded-full border border-slate-300 bg-white px-6 py-4 text-base font-semibold text-slate-700"
        >
          <SafeIcon icon={FiDownload} /> Download PDF
        </a>
      </div>

      {/* Tablet and desktop: inline viewer */}
      <div className="hidden sm:block">
        <div className="mt-8 flex flex-wrap gap-3">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="site-button inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold"
          >
            <SafeIcon icon={FiExternalLink} /> Open in new tab
          </a>
          <a
            href={url}
            download
            className="inline-flex items-center gap-2 rounded-full border border-slate-200 px-6 py-3 text-sm font-semibold text-slate-600 hover:border-[#3fc0fa]"
          >
            <SafeIcon icon={FiDownload} /> Download
          </a>
        </div>
        <div className="mt-8 overflow-hidden rounded-3xl border border-slate-200 bg-slate-50">
          <iframe src={url} title={frameTitle} className="h-[80vh] min-h-[420px] w-full" />
        </div>
      </div>
    </div>
  );
}